// extracted by mini-css-extract-plugin
module.exports = {"container":"AdminPage_container__2hZa-","text":"AdminPage_text__1Jjhz","contentContainer":"AdminPage_contentContainer__1y4mz"};